/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfilePromptTextColor, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemBorderRadius, hingeProfileItemBorderWidth, hingeProfileItemBoxShadow, hingeProfileItemDividerOpacity, tinderImageHeight, tinderLeadImageHeight, tinderProfileBackgroundColor, tinderProfileImageIndicatorWidth, tinderProfileImageWidth, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileItemBorderRadius, tinderProfileItemBorderWidth, tinderProfileItemBoxShadow, tinderProfileItemDividerOpacity, tinderProfilePromptTextColor, tinderProfileTextColor, swipelyticsTurquoise, profPicDefaultURL } from '../../../helpers/variableDefaults'

export const viewFeedbackGeneralAnalysisJSX = (profileType, generalFeedbackObj, clientVitalInfo, width) => {
  return (
    <Box
      sx={{
        mt: 2, py: 2,
        width: profileType === 'bumble' ? bumbleProfileImageWidth(width) : profileType === 'tinder' ? tinderProfileImageWidth(width) : profileType === 'hinge' ? hingeProfileImageDimension(width) : hingeProfileImageDimension(width),
        // backgroundColor: 'mistyrose',
        backgroundColor: 'lightyellow',
        border: profileType === 'bumble' ? bumbleProfileItemBorderWidth : profileType === 'tinder' ? tinderProfileItemBorderWidth : profileType === 'hinge' ? hingeProfileItemBorderWidth : hingeProfileItemBorderWidth,
        borderColor: profileType === 'bumble' ? bumbleProfileItemBorderColor : profileType === 'tinder' ? tinderProfileItemBorderColor : profileType === 'hinge' ? hingeProfileItemBorderColor : hingeProfileItemBorderColor,
        boxShadow: profileType === 'bumble' ? bumbleProfileItemBoxShadow : profileType === 'tinder' ? tinderProfileItemBoxShadow : profileType === 'hinge' ? hingeProfileItemBoxShadow : hingeProfileItemBoxShadow, 
        borderRadius: profileType === 'bumble' ? bumbleProfileItemBorderRadius : profileType === 'tinder' ? tinderProfileItemBorderRadius : profileType === 'hinge' ? hingeProfileItemBorderRadius : hingeProfileItemBorderRadius,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >

      {/* Title */}
      <Box
        sx={{
          width: '100%',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        Analysis
      </Box>

      {/* Vibe */}
      {'vibe' in generalFeedbackObj && generalFeedbackObj.vibe.length > 0 &&
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Question */}
          <Box
            sx={{
              pt: 2, px: 2,
              fontWeight: 'bold',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {`What is your impression of the person based on the profile?`}
          </Box>

          {/* Analysis — Vibe */}
          <Box
            sx={{
              pt: 1, pb: 2, px: 2,
              fontStyle: 'italic',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {generalFeedbackObj.vibe}
          </Box>
        </Box>
      }

      {/* Pros */}
      {'good' in generalFeedbackObj && generalFeedbackObj.good.length > 0 &&
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >

          {/* Divider */}
          {generalFeedbackObj.vibe.length > 0 &&
            <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />
          }

          {/* Question */}
          <Box
            sx={{
              pt: 2, px: 2,
              fontWeight: 'bold',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {`What do you like about the profile?`}
          </Box>

          {/* Analysis — Good */}
          <Box
            sx={{
              pt: 1, pb: 2, px: 2,
              fontStyle: 'italic',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {generalFeedbackObj.good}
          </Box>
        </Box>
      }

      {/* Cons */}
      {'notGood' in generalFeedbackObj && generalFeedbackObj.notGood.length > 0 &&
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >

          {/* Divider */}
          {(generalFeedbackObj.vibe.length > 0 || generalFeedbackObj.good.length > 0) &&
            <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />
          }

          {/* Question */}
          <Box
            sx={{
              pt: 2, px: 2,
              fontWeight: 'bold',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {`What are the main areas for improvement for this profile?`}
          </Box>

          {/* Analysis — Not Good */}
          <Box
            sx={{
              pt: 1, pb: 2, px: 2,
              fontStyle: 'italic',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {generalFeedbackObj.notGood}
          </Box>
        </Box>
      }

      {/* Verdict */}
      {'verdict' in generalFeedbackObj && generalFeedbackObj.verdict.length > 0 &&
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >

          {/* Divider */}
          {(generalFeedbackObj.vibe.length > 0 || generalFeedbackObj.good.length > 0 || generalFeedbackObj.notGood.length > 0) &&
            <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />
          }

          {/* Question */}
          <Box
            sx={{
              pt: 2, px: 2,
              fontWeight: 'bold',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {`Overall, does ${clientVitalInfo.firstName}'s profile showcase ${clientVitalInfo.gender === 'Male' ? 'his' : clientVitalInfo.gender === 'Female' ? 'her' : 'their' } most attractive self?`}
          </Box>

          {/* Analysis — Verdict */}
          <Box
            sx={{
              pt: 1, pb: 2, px: 2,
              fontStyle: 'italic',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {generalFeedbackObj.verdict}
          </Box>
        </Box>
      }

    </Box>
  )
}